/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import {
    Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';

import { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

import loadsStore from '../../../stores/loads-store';
import JmpModal from './customModal';
import Fuse from "fuse.js";
import ReactDOM from 'react-dom';
import { ClipLoader } from 'react-spinners';
import Select from 'react-select';
import scheduleStore from '../../../stores/schedule-store';


const customStyles = {
    control: base => ({
        ...base,
        minHeight: 30
    }),
    menu: (provided, state) => ({
        ...provided,
        borderBottom: "1px dotted pink",
        color: state.isSelected ? "red" : "blue",
        padding: 20,
        height: 730
    }),
    menuList: (provided, state) => ({
        ...provided,
        borderBottom: "1px dotted pink",
        padding: 20,
        minHeight: 700
    })
};

class JoinTandems extends Component {

    constructor(props) {

        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTransferCredit = this.handleTransferCredit.bind(this);
        this.toggleError = this.toggleError.bind(this);
        // this.updateGear = this.updateGear.bind(this);
        // this.MultiValueLabel = this.MultiValueLabel.bind(this);

        this.state = {
            isModalOpen: false,
            studentOptions: [],
            adminDefaultOptions: [],
            ErrorMessage: '',
            placement: 'bottom',
            errors: {},
            fromId: '',
            ids: [],
            isloading: false,
            errorOpen: false,
        };

        this.handleJumpersLoaded = this.handleJumpersLoaded.bind(this);

        this.jumperEvents = [
            { name: jumpersStore.getEventPrefix('jumpersLoaded'), func: this.handleJumpersLoaded },
            { name: jumpersStore.getEventPrefix('creditTransferEvent'), func: this.handleTransferCredit }
        ];
    }


    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            studentOptions: jumpersStore.getTandemStudentNonGroupOptions().filter(option => option.value !== this.props.jumperId.toString())
        });
    }

    handleSubmit = (values) => {
        console.log(values);
        console.log(this.state.ids);
        console.log(this.props.mode);
        if (this.props.mode === "join") {
            var payload = { tandemIds: this.state.ids.map(id => id.value) };
            jumpersStore.joinTandems(this.props.jumperId, payload);
        }
        else if (this.props.mode === "merge" && this.state.ids !== null || this.state.ids !== undefined) {
            console.log('about to merge up in that')
            var payload = {
                mergeToId: this.state.ids.value
            };
            jumpersStore.mergeTandems(this.props.jumperId, payload)
                .then(test => {
                    //refetch reservations;
                    scheduleStore.fetchTodayReservation();
                })

        }
    };

    componentDidMount = () => {
        //console.log('in components did mount accounts');
        this.jumperEvents.forEach((evnt) => jumpersStore.on(evnt.name, evnt.func));

        var options = jumpersStore.getJumperOptions();

        this.setState({ jumperOptions: options, adminDefaultOptions: options.slice(0, 50) });
    }

    componentWillUnmount = () => {
        this.jumperEvents.forEach((evnt) => jumpersStore.removeListener(evnt.name, evnt.func));
    }

    componentWillReceiveProps() {
        var toId = '';
        if (this.props.tandemInstructorId !== undefined) {
            toId = this.props.tandemInstructorId;
        }
        this.setState({
            fromId: this.props.jumperId,
            toId: toId
        })
    }

    filterJumpers = (inputValue, jumperOptions) => {
        //console.log("in filterJumpers");
        if (inputValue) {
            //console.log(inputValue);
            var filteredOptions = jumperOptions.filter(i =>
                i.label.toLowerCase().includes(inputValue.toLowerCase()));
            ////console.log(filteredOptions);
            if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
            else return filteredOptions;
        }
        //console.log('no inputValue');
        return jumperOptions.slice(0, 30);
    };

    promiseOptions = (inputValue, jumperOptions) => {
        //console.log('in pomiseOptions');
        //console.log(this.inputValue);
        return new Promise(resolve => {
            resolve(this.filterJumpers(this.inputValue, jumperOptions));
        });
    }

    handleInputChange = (newValue) => {
        //console.log('handleInputChange');

        //const inputValue = newValue.replace(/\W/g, '');
        ////console.log(inputValue);

        //this.promiseOptions(newValue, jumperOptions);
        this.inputValue = newValue;
        //return inputValue;
    };

    handleFromSelect = (val) => {
        //console.log('in handleSelect');
        if (val.value !== undefined) {
            ////alert(JSON.stringify(val.value));
            // this.onJumperChanged(val.value);
            // jumpersStore.getDailyActivity(val.value._id);
            this.setState({
                fromId: val.value._id
            });
            //console.log(JSON.stringify(val.value));
        }
    }

    handleToSelect = (val) => {
        //console.log('in handleSelect');
        if (val.value !== undefined) {
            ////alert(JSON.stringify(val.value));
            // this.onJumperChanged(val.value);
            // jumpersStore.getDailyActivity(val.value._id);
            this.setState({
                toId: val.value._id
            });
            //console.log(JSON.stringify(val.value));
        }
    }

    Option = (props) => {
        //console.log(props);
        return (
            <div className="row">
                <div className="col-12">
                    <components.Option {...props} />
                </div>
            </div>
        );
    }

    handleJumpersLoaded(jumperOptions) {
        //console.log('in handle jumpers loaded in accounts');
        var adminDefaultOptions = jumperOptions.slice(0, 50);
        //alert('handle Jumpers Loaded');
        this.setState({
            jumperOptions: jumperOptions,
            adminDefaultOptions: adminDefaultOptions
        });
    }

    toggleError() {
        this.setState({
            errorOpen: !this.state.errorOpen
        });
    }

    handleTransferCredit(data) {
        if (data === true) {
            this.setState({
                isloading: false,
                isModalOpen: false
            })
        }
        else {
            this.setState({
                isloading: false,
                isModalOpen: false,
                errorOpen: true
            })
            //console.log('fail');
        }
    }

    handleInput = (event, key) => {
        var cache = { ...this.state };
        cache[key] = event.target.value;
        this.setState({ ...cache }, () => {
            this.handleValidation(key);
        });
        // if (!this.state.errors.length)
        //     tandemData.updateFormWithIndex(cache, this.props.index - 1);
    };

    handleValidation(name) {
        let fields = this.state;
        let errors = fields.errors;
        if (fields[name] === '') errors[name] = "This field is required";
        else if (name === 'amount' && !fields[name].match(/((\d+)(\.\d{2}))$/)) errors[name] = "Amount should be enter in two decimal places.";
        else errors[name] = "";
        this.setState({ errors: errors });
    }

    handleTandemSelect(ids) {
        console.log(ids, "<<<<<<<");
        this.setState({ ids: ids });
    }

    render() {
        var screenWidth = window.innerWidth;
        var defaultValue = '';
        var defaultTandemInstructor = '';

        if (this.props.isTandemStudent && this.state.jumperOptions.length > 0 && this.props.tandemInstructorId !== '') {
            console.log(this.props.tandemInstructorId);
            console.log(this.state.jumperOptions.map(option => option._id));
            var defaultTandemInstructor = this.state.jumperOptions.filter(x => x.value._id.toString() === this.props.tandemInstructorId.toString())[0].label;
        }

        var modalMargin = '25%';
        if (screenWidth >= 1920) {
            modalMargin = '65%';
        }

        const override = `
        display: block;
        margin: 0 auto;
        border-color: red;
        `;


        //var studentOptions = jumpersStore.getTandemStudentNonGroupOptions().filter(option => option.value !== this.props.jumperId.toString());

        return (

            <React.Fragment>
                <JmpModal
                    isModalOpen={this.state.isModalOpen}
                    title={this.props.mode === "join" ? `Join Tandem` : `Merge Duplicates`}
                >
                    <div className='complete-loading'>
                        <ClipLoader
                            css={override}
                            sizeUnit={"px"}
                            size={35}
                            color={'#fff'}
                            loading={this.state.isloading}
                        />
                    </div>


                    <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                        {this.props.mode === "join" ?
                            <Row className="form-group">
                                <Label htmlFor="To" md={3}>To</Label>
                                <Col md={9}>
                                    <Select
                                        isMulti
                                        isClearable
                                        onChange={(val) => this.handleTandemSelect(val)}
                                        options={this.state.studentOptions}
                                        styles={customStyles}
                                    />
                                </Col>
                            </Row>
                            : null
                        }

                        {this.props.mode === "merge" ?
                            <Row className="form-group">
                                <Label htmlFor="To" md={3}>To</Label>
                                <Col md={9}>
                                    <Select
                                        isClearable
                                        onChange={(val) => this.handleTandemSelect(val)}
                                        options={this.state.studentOptions}
                                        styles={customStyles}
                                    />
                                </Col>
                            </Row>
                            : null
                        }
                        <Row className="form-group">
                            <Col md={{ size: 10 }}>
                                <button className="btn btn-bg lightColor createButton" type="submit" >Submit</button>
                                <button onClick={(e) => { e.preventDefault(); this.toggleModal(); }} className="btn btn-link">Cancel</button>
                            </Col>
                        </Row>
                    </LocalForm>
                </JmpModal>
                <Modal isOpen={this.state.errorOpen} toggle={this.toggleError} className={this.props.className}>
                    <ModalHeader toggle={this.toggleError} className="error-jumperHeader">
                        Error
                    </ModalHeader>
                    <ModalBody>
                        <p style={{ color: 'red', fontSize: '20px', marginLeft: '1%' }}>Something Wrong happened while Transfer Credits !</p>
                    </ModalBody>
                </Modal>

                {this.props.tinyButton ? <button className="btn btn-secondary btn-sm" onClick={this.toggleModal} style={{ color: "#000", backgroundColor: "#efefef", borderColor: "#6c757d" }}>
                    connect tandem
                </button>
                    :
                    <button className="btn transferButton rightButton" style={{ borderRadius: '4px', backgroundColor: '#A7F6FF', color: '#082764' }} onClick={this.toggleModal} type="submit" disabled={this.props.disabled}>
                        {this.props.mode == "join" ? "Join Tandems" : null}
                        {this.props.mode == "merge" ? "Merge Duplicates" : null}
                    </button>}
            </React.Fragment>
        );
    }
}

export default JoinTandems
